module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Light-Adv_Web.03ca5f31.woff2";